export default __webpack_public_path__ + "static/media/instagramLogo.decb87d1.svg";